import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import useAxios from '../../hooks/useAxios';
import { MESSAGES_UNREAD_COUNT_URL } from '../../utils/constant';
import { useContext } from 'react';
import { LoginContext } from '../../contexts/LoginContext';

export function useUnreadCount() {
  const { getWithAxios } = useAxios();
  const { currentUser } = useContext(LoginContext);

  return useQuery({
    queryKey: queryKeys.messages.unreadCount(),
    queryFn: async (): Promise<number> => {
      const response = await getWithAxios(MESSAGES_UNREAD_COUNT_URL);
      if (response?.success) {
        return response.unreadCount || 0;
      }
      return 0;
    },
    enabled: !!currentUser?.isLogged?.(),
    staleTime: 30 * 1000, // 30 seconds
    refetchInterval: 60 * 1000, // Refetch every minute for badge updates
  });
}
